import { Select } from "antd";
import React from "react";

export default function GiftCardSelector(props){

    const {value = "", onChange = () => {}} = props; 

    const drawCards = () => {
        return window.giftcards.map(item => {
            const {
                code = "",
                description = ""
            } = item; 
            return(<Select.Option value={code} key={code}>{description}</Select.Option>)
        })
    }

    const onSelect = (e) =>{
        let f = window.giftcards.find(item => item.code === e);
        if(f){
            onChange(f);
        }
    }

    return(
    <Select value={value} onChange={(e) => onSelect(e)} style={{"width" : "100%", "fontSize" : "12px"}} placeholder="Select card..." >
        {drawCards()}
    </Select>
    )
}